"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import _ from "underscore";
import { Flash } from "../../components/flash";
import Vector from "immutable-vector2d";
import uuid from "@lukeed/uuid";
import { isPointIn } from "../annotation/bounding_box";
import MODES from "./modes";
import Api from "../../api/api";
import { checkStatus } from "../../util/fetch";
export var Action = /* @__PURE__ */ ((Action2) => {
  Action2["ADDING_FINISH"] = "ADDING_FINISH";
  Action2["ADDING_MOVED"] = "ADDING_MOVED";
  Action2["ADDING_START"] = "ADDING_START";
  Action2["ADD_COMPONENT"] = "ADD_COMPONENT";
  Action2["ADJUST_TONE"] = "ADJUST_TONE";
  Action2["CANVAS_SIZE_CHANGED"] = "CANVAS_SIZE_CHANGED";
  Action2["CHANGE_COMPONENT_VALUE"] = "CHANGE_COMPONENT_VALUE";
  Action2["CHANGE_MODE"] = "CHANGE_MODE";
  Action2["DELETE_COMPONENT"] = "DELETE_COMPONENT";
  Action2["DONE_EDITING_TEXT_ANNOTATION"] = "DONE_EDITING_TEXT_ANNOTATION";
  Action2["EDIT_TEXT_ANNOTATION"] = "EDIT_TEXT_ANNOTATION";
  Action2["EDIT_TEXT_ANNOTATION_TEXT"] = "EDIT_TEXT_ANNOTATION_TEXT";
  Action2["LOADING_ANNOTATIONS"] = "LOADING_ANNOTATIONS";
  Action2["LOADING_ANNOTATIONS_FAILED"] = "LOADING_ANNOTATIONS_FAILED";
  Action2["LOADING_ANNOTATIONS_SUCCEEDED"] = "LOADING_ANNOTATIONS_SUCCEEDED";
  Action2["MOUSE_MOVED"] = "MOUSE_MOVED";
  Action2["MOVING_FINISH"] = "MOVING_FINISH";
  Action2["MOVING_MOVED"] = "MOVING_MOVED";
  Action2["MOVING_START"] = "MOVING_START";
  Action2["SAVING_ANNOTATIONS"] = "SAVING_ANNOTATIONS";
  Action2["SAVING_ANNOTATIONS_FAILED"] = "SAVING_ANNOTATIONS_FAILED";
  Action2["SAVING_ANNOTATIONS_SUCCEEDED"] = "SAVING_ANNOTATIONS_SUCCEEDED";
  Action2["SELECT_COMPONENT"] = "SELECT_COMPONENT";
  Action2["SELECT_HOVERED_COMPONENT"] = "SELECT_HOVERED_COMPONENT";
  Action2["SET_HOVERED_COMPONENT"] = "SET_HOVERED_COMPONENT";
  Action2["TOGGLE_ANNOTATING_STATUS"] = "TOGGLE_ANNOTATING_STATUS";
  Action2["TOGGLE_CROPPING"] = "TOGGLE_CROPPING";
  Action2["TOGGLE_TONE_SLIDERS"] = "TOGGLE_TONE_SLIDERS";
  Action2["UNSELECT_COMPONENT"] = "UNSELECT_COMPONENT";
  return Action2;
})(Action || {});
export const editTextAnnotationText = (guid, value) => {
  return function(dispatch, _getState) {
    dispatch({
      type: "EDIT_TEXT_ANNOTATION_TEXT" /* EDIT_TEXT_ANNOTATION_TEXT */,
      guid,
      value
    });
  };
};
export const doneEditingTextAnnotation = () => {
  return {
    type: "DONE_EDITING_TEXT_ANNOTATION" /* DONE_EDITING_TEXT_ANNOTATION */
  };
};
const watchForMouseLeave = (canvasRect, dispatch, getState) => {
  function inner(event) {
    const { mode } = getState();
    const coords = new Vector(event.clientX, event.clientY);
    const rect = [
      [canvasRect.left, canvasRect.top],
      [canvasRect.right, canvasRect.top],
      [canvasRect.right, canvasRect.bottom],
      [canvasRect.left, canvasRect.bottom]
    ];
    if (!isPointIn(coords, rect)) {
      window.removeEventListener("mousemove", inner);
      if (MODES.moving === mode.type) {
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.selectOrMove
        });
        dispatch({
          type: "MOVING_FINISH" /* MOVING_FINISH */
        });
      }
    }
  }
  return inner;
};
export function canvasSizeUpdated(width, height) {
  return function(dispatch, getState) {
    const { canvas } = getState();
    const oldCanvasSize = _.isUndefined(canvas.width) ? void 0 : canvas;
    dispatch({
      type: "CANVAS_SIZE_CHANGED" /* CANVAS_SIZE_CHANGED */,
      width,
      height,
      oldCanvasSize
    });
  };
}
export function canvasMouseDown(coords) {
  return function(dispatch, getState) {
    const { mode } = getState();
    switch (mode.type) {
      case MODES.add:
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.adding,
          meta: mode.meta
        });
        dispatch({
          type: "ADDING_START" /* ADDING_START */,
          typeID: mode.meta.typeID,
          guid: uuid(),
          coords
        });
        break;
      case MODES.selectOrMove:
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.selectOrMoveMouseDown
        });
        break;
      default:
        return;
    }
  };
}
export function canvasMouseMove(coords, canvasRect) {
  return function(dispatch, getState) {
    dispatch({
      type: "MOUSE_MOVED" /* MOUSE_MOVED */,
      coords
    });
    const {
      mode,
      views,
      mousePos,
      hover: hoveredComponent,
      addingComponent,
      movingComponent,
      annotationMode
    } = getState();
    const cropping = annotationMode.cropping;
    switch (mode.type) {
      case MODES.adding:
        dispatch({
          type: "ADDING_MOVED" /* ADDING_MOVED */,
          coords,
          addingComponent
        });
        break;
      case MODES.selectOrMoveMouseDown:
        if (hoveredComponent.viewID) {
          dispatch({
            type: "CHANGE_MODE" /* CHANGE_MODE */,
            name: MODES.moving
          });
          window.addEventListener(
            "mousemove",
            watchForMouseLeave(canvasRect, dispatch, getState)
          );
          dispatch({
            type: "MOVING_START" /* MOVING_START */,
            mouseVector: Vector.fromObject(coords),
            component: views[hoveredComponent.viewID],
            dragPointIndex: hoveredComponent.dragPointIndex
          });
        }
        break;
      case MODES.selectOrMove:
        dispatch({
          type: "SET_HOVERED_COMPONENT" /* SET_HOVERED_COMPONENT */,
          views,
          mousePos,
          mode,
          cropping
        });
        break;
      case MODES.moving:
        dispatch({
          type: "MOVING_MOVED" /* MOVING_MOVED */,
          mouseVector: Vector.fromObject(coords),
          hoveredComponent,
          movingComponent
        });
        break;
      default:
        return;
    }
  };
}
export function canvasMouseUp(coords) {
  return function(dispatch, getState) {
    const { mode, views, hover } = getState();
    switch (mode.type) {
      case MODES.adding:
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.add,
          meta: mode.meta
        });
        dispatch({
          type: "ADDING_FINISH" /* ADDING_FINISH */,
          coords
        });
        break;
      case MODES.selectOrMoveMouseDown:
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.selectOrMove
        });
        dispatch({
          type: "SELECT_HOVERED_COMPONENT" /* SELECT_HOVERED_COMPONENT */,
          coords,
          views,
          hover
        });
        break;
      case MODES.moving:
        dispatch({
          type: "CHANGE_MODE" /* CHANGE_MODE */,
          name: MODES.selectOrMove
        });
        dispatch({
          type: "MOVING_FINISH" /* MOVING_FINISH */,
          mouseVector: Vector.fromObject(coords)
        });
        break;
      default:
        return;
    }
  };
}
export function addComponent(typeID) {
  return function(dispatch, getState) {
    const guid = uuid();
    const { canvas } = getState();
    var width = 0.3 * canvas.width;
    var height = 0.06 * canvas.width;
    if (typeID == "Stamp") {
      const settings = Api.Account.current().settings;
      height = settings.annotation_stamp_height;
      width = settings.annotation_stamp_width;
    }
    const newProps = {
      x: 0.1 * canvas.width,
      y: 0.1 * canvas.height,
      width,
      height
    };
    dispatch(__spreadProps(__spreadValues({}, newProps), {
      type: "ADD_COMPONENT" /* ADD_COMPONENT */,
      typeID,
      guid,
      canvas
    }));
    const { views } = getState();
    dispatch({
      type: "SELECT_COMPONENT" /* SELECT_COMPONENT */,
      guid,
      views
    });
  };
}
export function deleteAnnotation(guid) {
  return function(dispatch, getState) {
    const { selected } = getState();
    dispatch({
      type: "UNSELECT_COMPONENT" /* UNSELECT_COMPONENT */,
      guid,
      selected
    });
    dispatch({
      type: "DELETE_COMPONENT" /* DELETE_COMPONENT */,
      guid
    });
  };
}
export const toggleAnnotatingStatus = () => ({
  type: "TOGGLE_ANNOTATING_STATUS" /* TOGGLE_ANNOTATING_STATUS */
});
const loadAnnotationsFromApi = function(page) {
  return fetch(`/api/document_pages/${page.id}/page_annotations`, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include"
  }).then(checkStatus).then((r) => r.json());
};
const annotationsLoaded = (page, annotations, toneAdjustments) => function(dispatch, getState) {
  const { canvas } = getState();
  dispatch({
    type: "LOADING_ANNOTATIONS_SUCCEEDED" /* LOADING_ANNOTATIONS_SUCCEEDED */,
    id: page.id,
    annotations,
    toneAdjustments,
    canvas
  });
};
const newCropAnnotation = () => ({
  left: 0,
  top: 0,
  width: 100,
  height: 100,
  type: "Crop",
  guid: uuid()
});
const addCropIfMissing = (annotations) => {
  if (annotations.filter((a) => a.type === "Crop").length === 0) {
    return annotations.concat([newCropAnnotation()]);
  }
  return annotations;
};
const pageAnnotationsExist = function() {
  return "pageAnnotations" in window;
};
export function loadAnnotations(page) {
  if (pageAnnotationsExist()) {
    return function(dispatch) {
      dispatch(
        annotationsLoaded(
          page,
          addCropIfMissing(window.pageAnnotations.annotations),
          window.pageAnnotations.toneAdjustments
        )
      );
    };
  } else {
    return function(dispatch) {
      dispatch({
        type: "LOADING_ANNOTATIONS" /* LOADING_ANNOTATIONS */,
        id: page.id
      });
      loadAnnotationsFromApi(page).then((resp) => {
        dispatch(
          annotationsLoaded(
            page,
            addCropIfMissing(resp.annotations),
            resp.toneAdjustments
          )
        );
      }).catch((resp) => {
        dispatch({
          type: "LOADING_ANNOTATIONS_FAILED" /* LOADING_ANNOTATIONS_FAILED */,
          id: page.id,
          response: resp
        });
      });
    };
  }
}
export function updateAnnotations(page) {
  return function(dispatch, getState) {
    const { documentPageId } = getState();
    if (page.id !== documentPageId && !pageAnnotationsExist()) {
      dispatch(loadAnnotations(page));
    }
  };
}
const saveAnnotationsToApi = function(page, annotations, toneAdjustments) {
  return fetch(`/api/document_pages/${page.id}/page_annotations`, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      annotations,
      toneAdjustments
    }),
    credentials: "include"
  }).then(checkStatus).then((r) => r.json());
};
const annotationsSaved = (page, annotations, toneAdjustments) => function(dispatch, getState) {
  const { canvas } = getState();
  dispatch({
    type: "SAVING_ANNOTATIONS_SUCCEEDED" /* SAVING_ANNOTATIONS_SUCCEEDED */,
    id: page.id,
    annotations,
    toneAdjustments,
    canvas
  });
};
export function toggleCropping() {
  return function(dispatch, getState) {
    dispatch({
      type: "TOGGLE_CROPPING" /* TOGGLE_CROPPING */
    });
  };
}
export function toggleToneSliders() {
  return function(dispatch, getState) {
    dispatch({
      type: "TOGGLE_TONE_SLIDERS" /* TOGGLE_TONE_SLIDERS */
    });
  };
}
export function adjustTone(adjustment, value) {
  return function(dispatch, getState) {
    dispatch({
      type: "ADJUST_TONE" /* ADJUST_TONE */,
      adjustment,
      value
    });
  };
}
export function saveAnnotations(page) {
  return function(dispatch, getState) {
    dispatch({
      type: "SAVING_ANNOTATIONS" /* SAVING_ANNOTATIONS */,
      id: page.id
    });
    const { views, canvas, toneAdjustments } = getState();
    const annotations = Object.values(views).map((view) => ({
      height: view.height / canvas.height * 100,
      width: view.width / canvas.width * 100,
      guid: view.guid,
      type: view.typeID,
      data: view.data,
      top: view.y / canvas.height * 100,
      left: view.x / canvas.width * 100,
      id: view.id
    }));
    saveAnnotationsToApi(page, annotations, toneAdjustments).then((resp) => {
      dispatch(
        annotationsSaved(
          page,
          addCropIfMissing(resp.annotations),
          resp.toneAdjustments
        )
      );
    }).catch((resp) => {
      dispatch({
        type: "SAVING_ANNOTATIONS_FAILED" /* SAVING_ANNOTATIONS_FAILED */,
        id: page.id,
        annotations
      });
      Flash.warning(
        "There was a problem saving the annotations. Please try again, and if the problem persists, notify support."
      );
      throw new Error(String(resp));
    });
  };
}
